import type { DocMetadataActionRequest, DocMetadataActionResponse } from "@credit-acceptance/step6-bff-client";
import { useMutation } from "@tanstack/react-query";

import { workbenchDocumentsApi } from "../../../api/client";

/**
 * Applies a check-in / move-document action to a single document. Shared by the
 * check-in checkbox and the OK button in `MoveDocumentRow` so both go through
 * the same in-flight mutation.
 * @param appId - Approval id the document belongs to.
 * @param documentId - The document id.
 */
export function useApplyDocumentAction(appId: string, documentId: string) {
  return useMutation({
    mutationFn: async (body: DocMetadataActionRequest): Promise<DocMetadataActionResponse> => {
      const response = await workbenchDocumentsApi.applyDocAction(appId, documentId, body);
      return response.data;
    },
  });
}
